export const Style = ({ colors = [] }) => (
  <g id="Estilo5">
    <linearGradient
      id="SVGID_174_"
      gradientUnits="userSpaceOnUse"
      x1="91.3843"
      y1="-319.03"
      x2="99.6734"
      y2="-319.03"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_174_)' }}
      d="M95.2,71.6c1.6-1.8,5.4-7.6,4.3-21.3l-3.6,3.5l1.1,4.8 C96.5,64.5,95.8,68.6,95.2,71.6z"
    />

    <linearGradient
      id="SVGID_175_"
      gradientUnits="userSpaceOnUse"
      x1="51.8635"
      y1="-314.97"
      x2="59.448"
      y2="-314.97"
      gradientTransform="matrix(1 0 0 1 0 380)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_175_)' }}
      d="M55,57.2L52.6,59c-2.6,9.7,2.3,13.1,3.8,13.8c-0.8-4.4-1.6-9.8-1.6-11.8 L55,57.2z"
    />
    <path
      style={{ display: 'inline', fill: '#401F43' }}
      d="M60.1,60.4c-0.2-0.1,6.4-4.3,10.5-4.1c0.1,0.1-0.1-4.5-5.5-2.5 C59.8,55.9,60.1,60.5,60.1,60.4z"
    />
    <path
      style={{ display: 'inline', fill: '#401F43' }}
      d="M90.1,60.4c0.2-0.1-6.4-4.3-10.5-4.1c-0.1,0.1,0.4-4.6,5.8-2.7 C90.6,55.8,90,60.5,90.1,60.4z"
    />

    <linearGradient
      id="SVGID_176_"
      gradientUnits="userSpaceOnUse"
      x1="44.65"
      y1="437.3794"
      x2="103.39"
      y2="437.3794"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_176_)' }}
      d="M50.4,37.9C50.2,26,66.2,23.6,66.2,23.6c13-1.5,19.5,1,21.7,5.5 c3.3-0.9,8.2-1,11.6,4.5c5.5,8.9-3.2,16.1,3.9,23c0,0-5.9,6.5-12.3,1.7c-3.6-2.7-3.8-8.6-4.1-14.3c-1.3,4.8-4.8,10.8-15.2,10.9 c-15.8,0.2-16,7-16,7s-3.3-1.2-7-4.3C38.6,49.7,50.4,37.9,50.4,37.9z"
    />

    <linearGradient
      id="SVGID_177_"
      gradientUnits="userSpaceOnUse"
      x1="50.4285"
      y1="449.4525"
      x2="87.93"
      y2="449.4525"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        display: 'inline',
        opacity: '0.3',
        fill: 'url(#SVGID_177_)',
        enableBackground: 'new'
      }}
      d="M87.9,29.2 c-2.2-4.6-8.7-7.1-21.7-5.5c0,0-16,2.4-15.8,14.3c0,0,3.2-8.7,12.6-11.1C72.5,24.4,79.7,24.4,87.9,29.2z"
    />

    <linearGradient
      id="SVGID_178_"
      gradientUnits="userSpaceOnUse"
      x1="87.93"
      y1="444.356"
      x2="101.4692"
      y2="444.356"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: '#FFDEC7' }} />
      <stop offset="0.9944" style={{ stopColor: '#7C297F' }} />
    </linearGradient>
    <path
      style={{
        display: 'inline',
        opacity: '0.3',
        fill: 'url(#SVGID_178_)',
        enableBackground: 'new'
      }}
      d="M101.3,42.6c0.3-2.8,0.2-5.8-1.8-9 c-3.4-5.5-8.3-5.4-11.6-4.5C87.9,29.2,98.5,29.4,101.3,42.6z"
    />
  </g>
)

export const Back = ({ colors = [] }) => <></>

Style.Back = Back
